
import { ImageGallery } from "../ImageGallery";
import { Product } from "./types";
import { useEffect, useState } from "react";
import { checkImageAvailability } from "@/utils/imageOptimizer";

interface ProductImagesSectionProps {
  product: Product;
  compact?: boolean;
}

export const ProductImagesSection = ({ product, compact = false }: ProductImagesSectionProps) => {
  const [isMainImageValid, setIsMainImageValid] = useState<boolean>(true);
  
  // Ensure photos is an array even if it's null or undefined
  const photos = Array.isArray(product.photos) ? product.photos : [];
  
  // If there's a main photo_url, include it as the first image in the gallery if it's not already in photos
  const mainImage = product.photo_url || "";
  
  // Vérifier la validité de l'image principale
  useEffect(() => {
    const validateMainImage = async () => {
      if (mainImage) {
        const isValid = await checkImageAvailability(mainImage);
        setIsMainImageValid(isValid);
        
        if (!isValid) {
          console.warn("Image principale du produit non valide:", mainImage);
        }
      }
    };
    
    validateMainImage();
  }, [mainImage]);
  
  return (
    <div>
      <ImageGallery 
        mainImage={isMainImageValid ? mainImage : ""} 
        images={photos}
        fallbackImage="/placeholder-image.png"
        compact={compact}
      />
    </div>
  );
};
